import { http } from '@/utils/http'

import * as types from '../mutations'
import SettingService from '@/services/SettingService'
import { setSTToken } from '@/services/AuthService'

const state = {
  stToken: ''
}

const getters = {
  stToken: (state) => state.stToken
}

const actions = {
  async load ({ dispatch }) {
    const settings = await SettingService.loadSettings()
    await dispatch('setSettings', settings, { locally: true })
  },
  async setSettings ({ commit }, settings, options) {
    setSTToken(settings.stToken)
    http.st.setAuthToken(settings.stToken)
    if (!(options && options.locally)) await SettingService.setSTToken(settings.stToken)
    commit(types.SET_SETTINGS, settings)
  }
}

const mutations = {
  [types.SET_SETTINGS] (state, settings) {
    state.stToken = settings.stToken
    // state.x = settings.x
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
